// HomeWeb.jsx
import React, { useState, useRef } from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform, TouchableWithoutFeedback, TextInput, KeyboardAvoidingView, Alert } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from '../../components/baseWeb';
import styles from '../../styles/formularios';
import axios from 'axios';
import Checkbox from 'expo-checkbox';
import MaskInput, { Masks } from 'react-native-mask-input'; // Para aplicar máscara no CPF
export default function DadosPagamentoPromessaWeb({ route }) {
  const navigation = useNavigation();
  // envio unico 

  const [usuario_id, setUsuario_id] = useState(null);
  const { payload_vendedores, payload_compradores, payload_imovel_one } = route.params || {};

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [pagamentos, setPagamentos] = useState([
    {
      tipo: '',
      vencimento: '',
      valor: '',
      forma_pagamento: '',
      outra_forma_pagamento: '',
      juros: ''
    },
  ]);

  const [valor_venda, setValor_venda] = useState('');
  const valor_vendaRef = useRef(null);
  const [valor_sinal, setValor_sinal] = useState('');
  const valor_sinalRef = useRef(null);
  const [valor_comissao, setValor_comissao] = useState('');
  const valor_comissaoRef = useRef(null);
  const [pagamentoSialTipo, setPagamentoSialTipo] = useState(false);
  const pagamentoSialTipoRef = useRef(null);
  const showPagamentoSialTipo = useState('');
  const [imob, setImob] = useState('');
  const imobRef = useRef(null);
  const [fgts, setFgts] = useState(false);

  const toggleFgts = () => setFgts(prev => !prev);

  const [isImob, setIsImob] = useState(false);

  const toggleIsImob = () => setIsImob(prev => !prev);
  const toggleFormas = () => setIsImob(prev => !prev);


  const atulizaPagamentos = (index, campo, valor) => {
    const novosPagamentos = [...pagamentos];
    novosPagamentos[index][campo] = valor;
    setPagamentos(novosPagamentos);
  }


  const adicionarPagamentos = () => {
    setPagamentos([
      ...pagamentos,
      {
        tipo: '',
        vencimento: '',
        valor: '',
        forma_pagamento: '',
        outra_forma_pagamento: '',
        juros: ''
      },
    ]);
  };

  const isFormValid = () => {
    const isValid = valor_venda && valor_sinal && valor_comissao && tipoPagamentoSinal;
    const isPagamentosValid = pagamentos.every(p => p.tipo && p.vencimento && p.valor && p.forma_pagamento);
    return isValid && isPagamentosValid;
  };

  const handleSaveImovel = async () => {
    const parseValorMonetario = (valorStr) => {
      if (!valorStr) return 0;
      return parseFloat(
        valorStr
          .replace("R$", "")     // remove "R$"
          .replace(/\./g, "")    // remove pontos de milhar
          .replace(",", ".")     // troca vírgula decimal por ponto
          .trim()
      );
    };

    // Texto da forma de pagamento do sinal
    let forma_pagamento_sinal = tipoPagamentoSinal;

    if (tipoPagamentoSinal.toLowerCase() === "pix" && pixSinal) {
      forma_pagamento_sinal = `Pix, chave ${pixSinal}`;
    } else if (tipoPagamentoSinal.toLowerCase() === "ted" && contaSinal && agenciaSinal && bancoSinal) {
      forma_pagamento_sinal = `Transferência bancária, conta ${contaSinal}, agência ${agenciaSinal}, banco ${bancoSinal}`;
    } else if (tipoPagamentoSinal.toLowerCase() === "outro" && outrotipoPagamentoSinal) {
      forma_pagamento_sinal = outrotipoPagamentoSinal;
    }

    const payloadImovelAtualizado = {
      ...payload_imovel_one,
      valor_imovel: parseValorMonetario(valor_venda),
      valor_sinal: parseValorMonetario(valor_sinal),
      forma_de_pagamento_sinal: forma_pagamento_sinal,
      valor_comissao: parseValorMonetario(valor_comissao),
      fgts: fgts,
      isImob: isImob, // true ou false, conforme o valor no seu estado
      nomeImob: isImob ? imob : '', // nome da imobiliária se isImob for true
    };

    console.log('payloadImovelAtualizado', payloadImovelAtualizado);

    const pagamentosFormatados = pagamentos.map((p) => {

      let forma_pagamento_formatada = p.forma_pagamento;

      if (p.forma_pagamento?.toLowerCase() === "outro" && p.outra_forma_pagamento) {
        forma_pagamento_formatada = p.outra_forma_pagamento;
      }

      const base = {
        tipo: p.tipo,
        vencimento: p.vencimento,
        valor: parseValorMonetario(p.valor),
        forma_pagamento: forma_pagamento_formatada,
        juros: p.juros,
      };
      return base;
    });
    console.log('payloadPagamentos', pagamentosFormatados)

    navigation.navigate('EtapasPromessaWeb', { payload_vendedores, payload_compradores, payload_imovel_one, payload_negociacao: payloadImovelAtualizado, payload_pagamentos: pagamentosFormatados, status: 5 });
    setIsSubmitting(true);
  };
  // console.log(isImob)

  // console.log('proprietarios', proprietarios);
  // console.log('pagamentos', pagamentos);

  const [showCartorioOptions, setShowCartorioOptions] = useState(false);
  const [showTipoPagamentoOptions, setShowTipoPagamentoOptions] = useState(false);

  const [showTipoPagamentoOptionsArray, setShowTipoPagamentoOptionsArray] = useState([false]);
  const [showTipoPagamento2OptionsArray, setShowTipoPagamento2OptionsArray] = useState([false]);
  const [showTipoJurosOptionsArray, setShowTipoJurosOptionsArray] = useState([false]);

  const [numeroCartorio, setNumeroCartorio] = useState('');
  const [tipoPagamentoSinal, setTipoPagamentoSinal] = useState('');
  const [outrotipoPagamentoSinal, setOutroTipoPagamentoSinal] = useState('');
  const [pixSinal, setPixSinal] = useState('');
  const [agenciaSinal, setAgenciaSinal] = useState('');
  const [contaSinal, setContaSinal] = useState('');
  const [bancoSinal, setBancoSinal] = useState('');
  const [erroValorSinal, setErroValorSinal] = useState('');
  // 
  const handleValorSinalChange = (novoValor) => {
    // função que converte texto de moeda em número
    const parseValorMonetario = (valorStr) => {
      if (!valorStr) return 0;
      return parseFloat(
        valorStr
          .replace("R$", "")
          .replace(/\./g, "")
          .replace(",", ".")
          .trim()
      );
    };

    const valorVendaNumerico = parseValorMonetario(valor_venda);
    const novoValorNumerico = parseValorMonetario(novoValor);

    // Se valor de venda ainda não foi preenchido, apenas aceita normalmente
    if (valorVendaNumerico === 0) {
      setValor_sinal(novoValor);
      setErroValorSinal(''); // limpa erro
      return;
    }

    const limiteSinal = valorVendaNumerico * 0.10;

    if (novoValorNumerico > limiteSinal) {
      // se maior que 10%, seta no campo o valor limite
      const valorMaximoFormatado = limiteSinal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      setValor_sinal(valorMaximoFormatado);
      setErroValorSinal(`Sugerimos que o valor de sinal não esteja limitado a 10% do valor do imóvel (${valorMaximoFormatado}).`);
    } else {
      // dentro do limite, seta normalmente e limpa erro
      setValor_sinal(novoValor);
      setErroValorSinal('');
    }
  };

  return (
    <BaseWeb>
      {(userInfo) => {
        return (
          <ScrollView contentContainerStyle={styles.contentMinimal}>
            <View style={styles.formContainer}>
              <Text style={styles.title}>Dados da  negociação</Text>

              {/* <View style={styles.divider} /> */}
              <View style={styles.row}>
                <Text style={styles.subLabel} allowFontScaling={false}>Valor de venda do imóvel *</Text>
                <TouchableWithoutFeedback onPress={() => valor_vendaRef.current.focus()}>
                  <View style={styles.inputContainer}>
                    <MaskInput
                      ref={valor_vendaRef}
                      allowFontScaling={false}
                      keyboardType='number-pad'
                      mask={Masks.BRL_CURRENCY}
                      style={styles.areaInput}
                      placeholder="R$"
                      placeholderTextColor="#A9A9A9"
                      value={valor_venda}
                      onChangeText={setValor_venda}
                    />
                  </View>
                </TouchableWithoutFeedback>
              </View>

              <View style={styles.row}>
                <Text style={styles.subLabel} allowFontScaling={false}>Valor do sinal *</Text>
                <TouchableWithoutFeedback onPress={() => valor_sinalRef.current.focus()}>
                  <View style={styles.inputContainer}>
                    <MaskInput
                      ref={valor_sinalRef}
                      allowFontScaling={false}
                      keyboardType='number-pad'
                      mask={Masks.BRL_CURRENCY}
                      style={styles.areaInput}
                      placeholder="R$"
                      placeholderTextColor="#A9A9A9"
                      value={valor_sinal}
                      onChangeText={handleValorSinalChange}
                    />
                    {erroValorSinal ? (
                      <Text style={styles.orangeText}>{erroValorSinal}</Text>
                    ) : null}
                  </View>
                </TouchableWithoutFeedback>
              </View>
              {/* Matrícula do Imóvel */}
              <View style={styles.row}>
                <Text style={styles.subLabel} allowFontScaling={false}>Forma de pagamento do sinal *</Text>
                <TouchableWithoutFeedback onPress={() => setShowTipoPagamentoOptions(!showTipoPagamentoOptions)}>
                  <View style={[styles.areaInput, { justifyContent: 'center' }]}>
                    <Text style={{ color: tipoPagamentoSinal ? '#1F2024' : '#A9A9A9' }}>
                      {tipoPagamentoSinal || 'Selecionar forma de pagamento'}
                    </Text>
                  </View>
                </TouchableWithoutFeedback>

                {showTipoPagamentoOptions && (
                  <View style={styles.optionsContainer}>
                    {[
                      'Dinheiro',
                      'Pix',
                      'TED',
                      'Boleto',
                      'Cheque',
                      'Outro'
                    ].map((option) => (
                      <TouchableOpacity
                        key={option}
                        style={styles.optionItem}
                        onPress={() => {
                          setTipoPagamentoSinal(option);
                          setShowTipoPagamentoOptions(false);
                        }}
                      >
                        <Text style={styles.optionText}>{option}</Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
              </View>

              {tipoPagamentoSinal.toLowerCase() === 'pix' && (
                <View style={styles.row}>
                  <Text style={styles.subLabel}>Chave Pix </Text>
                  <TextInput
                    style={styles.areaInput}
                    value={pixSinal}
                    onChangeText={setPixSinal}
                    placeholder="Informe a chave Pix"
                    placeholderTextColor="#A9A9A9"
                  />
                </View>
              )}

              {tipoPagamentoSinal.toLowerCase() === 'ted' && (
                <>
                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Agencia </Text>
                    <TextInput
                      style={styles.areaInput}
                      value={agenciaSinal}
                      onChangeText={setAgenciaSinal}
                      placeholder="Informe a Agencia"
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Conta </Text>
                    <TextInput
                      style={styles.areaInput}
                      value={contaSinal}
                      onChangeText={setContaSinal}
                      placeholder="Ex: 71234-5"
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Banco </Text>
                    <TextInput
                      style={styles.areaInput}
                      value={bancoSinal}
                      onChangeText={setBancoSinal}
                      placeholder="Ex: Banco do Brasil"
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>
                </>
              )}

              {tipoPagamentoSinal.toLowerCase() === 'outro' && (
                <>
                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Forma de pagamento</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={outrotipoPagamentoSinal}
                      onChangeText={setOutroTipoPagamentoSinal}
                      placeholder="EX: Boleto, Pix, TED..."
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>
                </>
              )}

              <View style={styles.row}>
                <Text style={styles.subLabel} allowFontScaling={false}>Valor da comissão *</Text>
                <TouchableWithoutFeedback onPress={() => valor_comissaoRef.current.focus()}>
                  <View style={styles.inputContainer}>
                    <MaskInput
                      ref={valor_comissaoRef}
                      allowFontScaling={false}
                      keyboardType='number-pad'
                      mask={Masks.BRL_CURRENCY}
                      style={styles.areaInput}
                      placeholder="R$"
                      placeholderTextColor="#A9A9A9"
                      value={valor_comissao}
                      onChangeText={setValor_comissao}
                    />
                  </View>
                </TouchableWithoutFeedback>
              </View>

              {/* Checkbox "Não possui condomínio" */}
              <View style={styles.checkboxRow}>
                <Checkbox
                  value={fgts}
                  onValueChange={toggleFgts}
                  color={fgts ? '#730d83' : undefined}
                />
                <Text style={styles.checkboxLabel} allowFontScaling={false}>Vai ser usado FGTS como uma forma de pagamento? </Text>
              </View>
              <View style={styles.checkboxRow}>
                <Checkbox
                  value={isImob}
                  onValueChange={toggleIsImob}
                  color={isImob ? '#730d83' : undefined}
                />
                <Text style={styles.checkboxLabel} allowFontScaling={false}>Possui vínculo com imobiliária? </Text>
              </View>
              {isImob && (
                <View style={[styles.row, styles.mt_20]}>
                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>Nome da imobiliária*</Text>
                    <TouchableWithoutFeedback onPress={() => imobRef.current.focus()}>
                      <View style={styles.inputContainer}>
                        <TextInput
                          ref={imobRef}
                          style={[styles.areaInput]}
                          multiline
                          value={imob}
                          onChangeText={setImob}
                          placeholder="Nome da imobiliária "
                          placeholderTextColor="#A9A9A9"
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  </View>
                </View>
              )}

              <View style={styles.divider} />
              <Text style={styles.subLabel} allowFontScaling={false}>Pagamentos</Text>
              {pagamentos.map((p, index) => (
                <View key={index} style={styles.proprietarioContainer}>
                  {/* <View style={styles.row}>
                                                  <Text style={styles.subLabel}>Tipo de pagamento</Text>
                                                  <TextInput
                                                      style={styles.areaInput}
                                                      value={p.tipo}
                                                      onChangeText={(text) => atulizaPagamentos(index, 'tipo', text)}
                                                      placeholder="EX: Financiamento, FGTS..."
                                                      placeholderTextColor="#A9A9A9"
                                                  />
                                              </View> */}
                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Tipo de pagamento *</Text>
                    <TouchableWithoutFeedback onPress={() => {
                      const updated = [...showTipoPagamento2OptionsArray];
                      updated[index] = !updated[index];
                      setShowTipoPagamento2OptionsArray(updated);
                    }}>
                      <View style={[styles.areaInput, { justifyContent: 'center' }]}>
                        <Text style={{ color: p.tipo ? '#1F2024' : '#A9A9A9' }}>
                          {p.tipo || 'Selecionar tipo de pagamento'}
                        </Text>
                      </View>
                    </TouchableWithoutFeedback>

                    {showTipoPagamento2OptionsArray[index] && (
                      <View style={styles.optionsContainer}>
                        {[
                          'Recurso próprio',
                          'Financiamento Bancário',
                          'FGTS'
                        ].map((option) => (
                          <TouchableOpacity
                            key={option}
                            style={styles.optionItem}
                            onPress={() => {
                              atulizaPagamentos(index, 'tipo', option);
                              const updated = [...showTipoPagamento2OptionsArray];
                              updated[index] = false;
                              setShowTipoPagamento2OptionsArray(updated);
                            }}
                          >
                            <Text style={styles.optionText}>{option}</Text>
                          </TouchableOpacity>
                        ))}
                      </View>
                    )}
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Data de vencimento *</Text>
                    <MaskInput
                      style={styles.areaInput}
                      keyboardType='number-pad'
                      value={p.vencimento}
                      mask={Masks.DATE_DDMMYYYY}
                      onChangeText={(text) => atulizaPagamentos(index, 'vencimento', text)}
                      placeholder="EX: 19/12/2025"
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Valor do pagamento *</Text>
                    <MaskInput
                      style={styles.areaInput}
                      value={p.valor}
                      mask={Masks.BRL_CURRENCY}
                      onChangeText={(text) => atulizaPagamentos(index, 'valor', text)}
                      placeholder="R$"
                      keyboardType='number-pad'
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>
                  {/* Forma de pagamento com seletor */}
                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Forma de pagamento *</Text>
                    <TouchableWithoutFeedback onPress={() => {
                      const updated = [...showTipoPagamentoOptionsArray];
                      updated[index] = !updated[index];
                      setShowTipoPagamentoOptionsArray(updated);
                    }}>
                      <View style={[styles.areaInput, { justifyContent: 'center' }]}>
                        <Text style={{ color: p.forma_pagamento ? '#1F2024' : '#A9A9A9' }}>
                          {p.forma_pagamento || 'Selecionar forma de pagamento'}
                        </Text>
                      </View>
                    </TouchableWithoutFeedback>

                    {showTipoPagamentoOptionsArray[index] && (
                      <View style={styles.optionsContainer}>
                        {[
                          'Dinheiro',
                          'Pix',
                          'TED',
                          'Boleto',
                          'Cheque',
                          'Outro'
                        ].map((option) => (
                          <TouchableOpacity
                            key={option}
                            style={styles.optionItem}
                            onPress={() => {
                              atulizaPagamentos(index, 'forma_pagamento', option);
                              const updated = [...showTipoPagamentoOptionsArray];
                              updated[index] = false;
                              setShowTipoPagamentoOptionsArray(updated);
                            }}
                          >
                            <Text style={styles.optionText}>{option}</Text>
                          </TouchableOpacity>
                        ))}
                      </View>
                    )}
                  </View>

                  {p.forma_pagamento.toLowerCase() === 'outro' && (
                    <>
                      <View style={styles.row}>
                        <Text style={styles.subLabel}>Forma de pagamento </Text>
                        <TextInput
                          style={styles.areaInput}
                          value={p.outra_forma_pagamento}
                          onChangeText={(text) => atulizaPagamentos(index, 'outra_forma_pagamento', text)}
                          placeholder="EX: Boleto, Pix, TED..."
                          placeholderTextColor="#A9A9A9"
                        />
                      </View>
                    </>
                  )}

                  {/* 
                                              <View style={styles.row}>
                                                  <Text style={styles.subLabel}>Juros e Correção </Text>
                                                  <TextInput
                                                      style={styles.areaInput}
                                                      value={p.juros}
                                                      onChangeText={(text) => atulizaPagamentos(index, 'juros', text)}
                                                      placeholder="Ex: 1% ao mês"
                                                      placeholderTextColor="#A9A9A9"
                                                  />
                                              </View> */}

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Juros e Correção *</Text>
                    <TouchableWithoutFeedback onPress={() => {
                      const updated = [...showTipoJurosOptionsArray];
                      updated[index] = !updated[index];
                      setShowTipoJurosOptionsArray(updated);
                    }}>
                      <View style={[styles.areaInput, { justifyContent: 'center' }]}>
                        <Text style={{ color: p.juros ? '#1F2024' : '#A9A9A9' }}>
                          {p.juros || 'Selecionar forma de juros'}
                        </Text>
                      </View>
                    </TouchableWithoutFeedback>

                    {showTipoJurosOptionsArray[index] && (
                      <View style={styles.optionsContainer}>
                        {[
                          'Fixa',
                          'Correção'
                        ].map((option) => (
                          <TouchableOpacity
                            key={option}
                            style={styles.optionItem}
                            onPress={() => {
                              atulizaPagamentos(index, 'juros', option);
                              const updated = [...showTipoJurosOptionsArray];
                              updated[index] = false;
                              setShowTipoJurosOptionsArray(updated);
                            }}
                          >
                            <Text style={styles.optionText}>{option}</Text>
                          </TouchableOpacity>
                        ))}
                      </View>
                    )}
                  </View>

                  {pagamentos.length > 1 && (
                    <TouchableOpacity
                      onPress={() => {
                        const novaLista = pagamentos.filter((_, i) => i !== index);
                        setPagamentos(novaLista);
                      }}
                      style={{ alignSelf: 'flex-end', marginBottom: 10 }}
                    >
                      <Text style={{ color: 'red', fontWeight: 'bold' }}>Remover</Text>
                    </TouchableOpacity>
                  )}
                  <View style={styles.divider} />
                </View>
              ))}

              <TouchableOpacity style={styles.laterButton} onPress={adicionarPagamentos}>
                <Text style={styles.laterButtonText}>Incluir novo pagamento</Text>
              </TouchableOpacity>

              <View style={styles.buttonContainer}>
                <TouchableOpacity
                  style={[
                    styles.saveButton,
                    (!isFormValid() || isSubmitting) && { backgroundColor: '#ccc' },
                  ]}
                  onPress={handleSaveImovel}
                  disabled={!isFormValid() || isSubmitting}
                >
                  <Text style={styles.saveButtonText}>
                    {isSubmitting ? 'Enviando...' : 'Próximo'}
                  </Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={styles.laterButton}
                  onPress={() => navigation.navigate('Home', { usuario_id })}
                >
                  <Image source={require('../../../assets/icons/home.png')} style={styles.laterIcon} />
                  <Text style={styles.laterButtonText}>Voltar</Text>
                </TouchableOpacity>
              </View>

            </View>
          </ScrollView>
        );
      }}
    </BaseWeb>
  );
}
